import createTableStore from "ds/components/Table/store/useTableStore";

import { AWS_TABLE_COLUMNS_CONFIG, AWS_TABLE_STORAGE_KEY } from "../../constants";

const useIntegrationsAwsTableStore = createTableStore({
  storageKey: AWS_TABLE_STORAGE_KEY,
  config: AWS_TABLE_COLUMNS_CONFIG,
});

export default useIntegrationsAwsTableStore;
